<template>
    <div class="print">
        <p class="bold center">
            ООО «Клиника Профессора»<br/>
            ИНН 1435316805, КПП 143501001<br/>
            Адрес: 677010, г. Якутск, ул. Радужная, 69/12<br/>
            Телефон: +7 (914)2776990; электронный адрес: klinika.professora@mail.ru
        </p>
        
        <hr size=2 width="100%" align=center>
        <p class="bold center">
            Выписка из медицинской карты амбулаторного больного №{{ title.medcard }} за {{ currentYear }} г.
        </p>
        <p class="center">
            (для больных, госпитализируемых в плановом порядке)
        </p>
        <p style="text-align:left;font-weight:bold;">
            {{ visit.visitDate.split(' ')[0] }} г.
        </p>
        <p style="text-align:justify">
            <b>ФИО пациента:</b> {{ visit.patient_full_name }}<br/>
            <b>Возраст:</b> {{ patientAge }}<br/>
            <b>СНИЛС:</b> {{ patient.snils }}<br/>
            <b>Наименование страховой компании::</b> {{ patient.polis_issuer }}, Полис №{{ patient.polis }}<br/>
            <b>Домашний адрес:</b> {{ patient.address }}<br/>
            <b>Социальный статус:</b> {{ patient.employment }}<br/>
            <b>Клинический диагноз:</b><br/>
            Основной: {{ visit.diagnosis }}<br/>
            Сопутствующий: {{ visit.diagnosis_secondary }}<br/>
            <b>Дата обращения:</b> {{ visit.visitDate.split(' ')[0] }} г.<br/>
            <b>Дата госпитализации:</b> {{ medhistory.openDate.split(' ')[0] }} г.<br/>
        </p>
        <p class="bold center">
            Код диагноза по МКБ-10: {{ operation.mkb10 }}<br/>
            Код группы КСГ: {{ operation.operationCodeKSG }}<br/>
        </p>
            <p style="text-align:justify">
                <b>Жалобы:</b> {{ visit.compliant }}
            </p>
            <p style="text-align:justify">
                <b>Анамнез болезни:</b> {{ visit.anamnes_med }}
            </p>
            <p style="text-align:justify">
                <b>Анамнез жизни:</b> {{ visit.anamnes_life }}
            </p>
            <p style="text-align:justify">
                <b>Аллергические реакции:</b> {{ visit.status_alergo }}
            </p>
            <p style="text-align:justify">
                <b>Объективный статус:</b> {{ visit.status_objective }}
            </p>
            <p style="text-align:justify">
                <b>Локальный статус:</b> {{ visit.status_local }}
            </p>
            <p style="text-align:justify">
                <b>Клинический минимум:</b> {{ visit.clinimum }}
            </p>
            <p style="text-align:justify">
                <b>Данные обследований:</b> {{ visit.exam_data }}
            </p>
            <p style="text-align:justify">
                <b>Обоснование диагноза:</b> {{ visit.proof }}
            </p>
            <p style="text-align:justify">
                <b>Рекомендации:</b> планируется операция: {{ operation.operationName }} в условиях травматолого-ортопедического отделения ООО «Клиника Профессора».
            </p>
            <p style="text-align:justify">
                <b>Дата:</b> {{ medhistory.openDate.split(' ')[0] }}
            </p>
        
        <p style="white-space: pre;">
                <table style="border:0px;width:100%;margin: 0 auto;">
                <tr>
                    <td style="text-align: right;border:0px;width:40%">Главный врач:</td>
                    <td style="border:0px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Устинова Александра Иннокентьевна</td>
                </tr>
                <tr>
                    <td style="text-align: right;border:0px;width:40%">Заведующий отделением:</td>
                    <td style="border:0px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Пальшин Виталий Геннадьевич</td>
                </tr>
                <tr>
                    <td style="text-align: right;border:0px">Врач:</td>
                    <td style="border:0px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ visit.doctor_full_name}}</td>
                </tr>
            </table>
        </p>
        <div class="pagebreak" />
        <p class="bold center">
            ООО «Клиника Профессора»<br/>
            ИНН 1435316805, КПП 143501001<br/>
            Адрес: 677010, г. Якутск, ул. Радужная, 69/12<br/>
            Телефон: +7 (914)2776990; электронный адрес: klinika.professora@mail.ru
        </p>
        
        <hr size=2 width="100%" align=center>
        <p class="bold center">
            Выписка из медицинской карты стационарного больного №{{ title.medcard }} за {{ currentYear }} г.
        </p>
        <br/>
        <p style="text-align:justify">
            <b>ФИО пациента:</b> {{ visit.patient_full_name }}<br/>
            <b>Возраст:</b> {{ patientAge }}<br/>
            <b>СНИЛС:</b> {{ patient.snils }}<br/>
            <b>Наименование страховой компании::</b> {{ patient.polis_issuer }}, Полис №{{ patient.polis }}<br/>
            <b>Домашний адрес:</b> {{ patient.address }}<br/>
            <b>Социальный статус:</b> {{ patient.employment }}<br/>
            <b>Клинический диагноз:</b><br/>
            Основной: {{ discharge.diagnosis }}<br/>
            Сопутствующий: {{ discharge.diagnosis_secondary }}<br/>
            <b>Дата обращения:</b> {{ visit.visitDate.split(' ')[0] }} г.<br/>
            <b>Дата госпитализации:</b> {{ medhistory.openDate.split(' ')[0] }} г.<br/>
            <b>Дата выписки:</b> {{ medhistory.discharge_date.split(' ')[0] }} г.<br/>
            <b>Проведено койко-дней:</b> {{ discharge.clinic_days }}
        </p>
        <p class="bold center">
            Код диагноза по МКБ-10: {{ operation.mkb10 }}<br/>
            Код группы КСГ: {{ operation.operationCodeKSG }}<br/>
        </p>
            <p style="text-align:justify">
                <b>Жалобы:</b> {{ visit.compliant }}<br/>
            </p>
            <p style="text-align:justify">
                <b>Анамнез болезни:</b> {{ visit.anamnes_med }}
            </p>
            <p style="text-align:justify">
                <b>Анамнез жизни:</b> {{ visit.anamnes_life }}
            </p>
            <p style="text-align:justify">
                <b>Объективный статус:</b> {{ visit.status_objective }}
            </p>
            <p style="text-align:justify">
                <b>Локальный статус:</b> {{ visit.status_local }}
            </p>
            <p style="text-align:justify">
                Диагноз выставлен на основании жалоб, анамнеза болезни, объективных данных, данных лабораторно-инструментальных методов обследования:<br/>
                <b>Жалобы:</b> {{ visit.compliant }}<br/>
                <b>Анамнез болезни:</b> {{ visit.anamnes_med }}<br/>
                <b>Локальный статус:</b> {{ visit.status_local }}<br/>
            </p>
            <p style="text-align:justify">
                <b>Данные лабораторно инструментальных исследований, консультации специалистов:</b> {{ visit.exam_data }}<br/><br/>
                <b>Контрольные исследования:</b><br/>
                {{ discharge.control_data }}<br/>
            </p>
            <p style="text-align:justify">
                <b>Диета:</b> {{ discharge.diet }}<br/>
                <b>Лечение:</b> {{ discharge.treatment_type }}<br/>
                <b>Операция:</b> {{ discharge.operation }}<br/>
                <b>Послеоперационный период:</b> {{ discharge.postoperation_note }}
            </p>
            <p style="text-align:justify">
                <b>Состояние при выписке:</b> {{ discharge.current_status }}<br/>
                <b>Жалобы:</b> {{ discharge.compliant }}<br/>
                <b>Объективный статус:</b> {{ discharge.status_objective }}<br/>
                <b>Локальный статус: </b> {{ discharge.status_local }}<br/>
                <b>На перевязке:</b> {{ discharge.status_dressing }}
            </p>
            <p style="text-align:justify">
                <b>Рекомендации:</b><br/> {{ discharge.recom }}
            </p>
            <p style="text-align:justify">
                <b>Дата:</b> {{ medhistory.discharge_date.split(' ')[0] }}
            </p>
        
        <p style="white-space: pre;">
                <table style="border:0px;width:100%;margin: 0 auto;">
                <tr>
                    <td style="text-align: right;border:0px">Врач:</td>
                    <td style="border:0px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ medhistory.doctor_full_name}}</td>
                </tr>
                <tr>
                    <td style="text-align: right;border:0px;width:40%">Заведующий отделением:</td>
                    <td style="border:0px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Пальшин Виталий Геннадьевич</td>
                </tr>
            </table>
        </p>
    </div>
</template>
<script setup>
    import { formatDate, toCases } from '@/common/rcfx.js'
</script>
<script>
    export default {
        props: ['visit','patient', 'medhistory', 'operation', 'title', 'discharge'],
        computed: {
            amb() {
            return this.visit.depType === "0"
            },
            hos() {
                return this.visit.depType === "1"
            },
            patientAge() {
                if (!this.visit.patient_birthdate) { 
                    return 'Не указан' 
                }else{
                    var birthdate = new Date(this.visit.patient_birthdate.split('.').reverse().join('-'))
                    var today = new Date()
                    return Math.floor((today-birthdate)/3600000/24/365) + " (" + this.visit.patient_birthdate.split('-').reverse().join('.') + " г.р.)"
                }
            },
            currentYear() {
                return new Date().getFullYear()
            },
            currentDate() {
                return formatDate(new Date(), "ru")
            },
        }
    }
    </script>